/**
 * Project : workspace
 * File    : HomePOSCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.home.component

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import component.image.AsyncImageView
import org.jetbrains.compose.ui.tooling.preview.Preview
import theme.ThemeColor

/**
 * Represents the home p o s card class.
 */

class HomePOSCard {
    private val textBoxStyle = Modifier.wrapContentHeight()
        .wrapContentWidth()
        .padding(start = 0.dp, end = 8.dp, top = 4.dp, bottom = 4.dp)
        .border(0.8.dp,ThemeColor.shared()
            .SecondaryColor,shape = RoundedCornerShape(20))
    private val textBoxTextStyle = Modifier.wrapContentHeight()
        .wrapContentWidth()
        .padding(start = 16.dp, end = 16.dp, top = 0.dp, bottom = 0.dp)
    val image = "https://firebasestorage.googleapis.com/v0/b/friendly-26dc3.firebasestorage.app/o/menu%2Fbusiness_home%2Fpoint_of_sale.png?alt=media&token=f93ffd6e-122b-463d-8298-1de70a6da434"

    @Preview
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @param onClick The on click.
 * @return Unit – no return value.
 */
    fun content(onClick:()->Unit){
        Card(
            modifier = Modifier
                .wrapContentHeight()
                .fillMaxWidth()
                .background(color = ThemeColor.shared().cardBackground, RoundedCornerShape(10.dp))
                .padding(bottom = 8.dp)
                .clickable {
                    onClick()
                },
            colors = CardDefaults.cardColors(
                containerColor = Color.White,
            ),
            elevation = CardDefaults.cardElevation(
                defaultElevation = 4.dp
            ),
            ) {
            Row(
                modifier = Modifier
                    .padding(horizontal = 8.dp, vertical = 8.dp)
                    .fillMaxWidth()
                    .fillMaxHeight()
                    .background(color = ThemeColor.shared().cardBackground),
                verticalAlignment = Alignment.CenterVertically,
                ) {
                Column(modifier = Modifier.padding(start = 0.dp, end = 8.dp).fillMaxHeight().fillMaxWidth().weight(1f)) {
                        Text(
                            text = "Point Of Sale",
                            fontSize = 16.sp,
                            color = ThemeColor.shared().titleColor,
                            textAlign = TextAlign.Center,
                            fontStyle = FontStyle.Normal,fontWeight = FontWeight.SemiBold
                        )
                    Row {
                        Box (modifier = textBoxStyle){
                            Text(
                                modifier = textBoxTextStyle,
                                text = "Product",
                                fontSize = 14.sp,
                                color = ThemeColor.shared().subTitleColor,
                                textAlign = TextAlign.Center,
                            )
                        }
                        Box (modifier = textBoxStyle){
                            Text(
                                modifier = textBoxTextStyle,
                                text = "Sales",
                                fontSize = 14.sp,
                                color = ThemeColor.shared().subTitleColor,
                                textAlign = TextAlign.Center,
                            )
                        }
                    }
                    Box (modifier = textBoxStyle){
                        Text(
                            modifier = textBoxTextStyle,
                            text = "Many More",
                            fontSize = 14.sp,
                            color = ThemeColor.shared().subTitleColor,
                            textAlign = TextAlign.Center,
                        )
                    }
                }
                Box (modifier = Modifier.height(100.dp).width(100.dp)){
                    AsyncImageView(image)
                }
            }
        }
    }
}